/**
 * Form 16 PDF export (Part A + Part B summary) using jsPDF.
 */
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

function inr(n) {
  const v = Number(n || 0);
  return `₹${v.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

function addSectionTitle(doc, y, title) {
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text(title, 14, y);
  doc.setFont("helvetica", "normal");
  return y + 6;
}

export function downloadForm16Pdf(data) {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const emp = data.employee || {};
  const er = data.employer || {};
  const partA = data.partA || {};
  const partB = data.partB || {};

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("FORM NO. 16", 105, 16, { align: "center" });
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text(
    "[See rule 31(1)(a)] PART A — Certificate under section 203 for tax deducted at source",
    105,
    22,
    { align: "center" }
  );

  let y = 30;
  y = addSectionTitle(doc, y, "Employer");
  doc.setFontSize(9);
  doc.text(`Name: ${er.name || "—"}`, 14, y);
  doc.text(`TAN: ${er.tan || "—"}`, 110, y);
  y += 5;
  doc.text(`PAN: ${er.pan || "—"}`, 14, y);
  y += 8;

  y = addSectionTitle(doc, y, "Employee");
  doc.text(`Name: ${emp.name || "—"}`, 14, y);
  doc.text(`Emp Code: ${emp.empCode || "—"}`, 110, y);
  y += 5;
  doc.text(`PAN: ${emp.pan || "—"}`, 14, y);
  doc.text(`FY: ${data.financialYear || "—"}`, 110, y);
  y += 5;
  doc.text(`Assessment Year: ${data.assessmentYear || "—"}`, 14, y);
  doc.text(`Certificate: ${data.certificateNumber || "—"}`, 110, y);
  y += 8;

  y = addSectionTitle(doc, y, "Part A — Tax deducted (quarterly)");
  const q = partA.quarters || {};
  autoTable(doc, {
    startY: y,
    head: [["Quarter", "TDS Deducted"]],
    body: [
      ["Q1 (Apr–Jun)", inr(q.Q1)],
      ["Q2 (Jul–Sep)", inr(q.Q2)],
      ["Q3 (Oct–Dec)", inr(q.Q3)],
      ["Q4 (Jan–Mar)", inr(q.Q4)],
      ["Total", inr(partA.totalTdsDeducted)],
    ],
    styles: { fontSize: 8 },
    headStyles: { fillColor: [30, 58, 95] },
    margin: { left: 14, right: 14 },
  });
  y = doc.lastAutoTable.finalY + 8;

  if (Array.isArray(partA.monthlyBreakdown) && partA.monthlyBreakdown.length) {
    y = addSectionTitle(doc, y, "Monthly TDS breakdown");
    autoTable(doc, {
      startY: y,
      head: [["Pay Month", "Regime", "TDS Deducted", "Override"]],
      body: partA.monthlyBreakdown.map((m) => [
        m.payMonth,
        m.taxRegime || "—",
        inr(m.tdsDeducted),
        m.isOverridden ? "Yes" : "—",
      ]),
      styles: { fontSize: 8 },
      headStyles: { fillColor: [30, 58, 95] },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 10;
  }

  if (y > 240) {
    doc.addPage();
    y = 20;
  }

  y = addSectionTitle(doc, y, "Part B — Salary and tax computation (summary)");
  const ded = partB.deductionBreakdown || {};
  autoTable(doc, {
    startY: y,
    head: [["Description", "Amount"]],
    body: [
      ["Tax regime", partB.regime || "—"],
      ["Annual gross salary", inr(partB.annualGross)],
      ["Standard deduction", inr(ded.standardDeduction)],
      ["HRA exemption", inr(ded.hraExemption)],
      ["Section 80C", inr(ded.section80C)],
      ["Employer NPS U/s 80CCD(2)", inr(ded.section80CCD2)],
      ["VIA deductions", inr(ded.viaDeductions)],
      ["House property interest", inr(ded.housePropertyInterest)],
      ["Total deductions", inr(partB.deductions)],
      ["Taxable income", inr(partB.annualTaxableIncome)],
      ["Tax on income", inr(partB.annualTaxLiability)],
      ["Total TDS deducted", inr(partA.totalTdsDeducted)],
    ].filter((row) => row[1] !== "₹0" || ["Tax regime", "Taxable income", "Tax on income", "Total TDS deducted", "Annual gross salary"].includes(row[0])),
    styles: { fontSize: 8 },
    headStyles: { fillColor: [30, 58, 95] },
    margin: { left: 14, right: 14 },
  });

  y = doc.lastAutoTable.finalY + 10;
  doc.setFontSize(7);
  doc.setTextColor(100);
  doc.text(
    "This is a system-generated Form 16 summary from PaceHRM payroll TDS records. Verify against TRACES before statutory use.",
    14,
    Math.min(y, 285)
  );
  doc.text(`Generated: ${new Date(data.generatedAt || Date.now()).toLocaleString("en-IN")}`, 14, Math.min(y + 4, 290));

  const filename = `Form16_${emp.empCode || emp.id}_${data.financialYear || "FY"}.pdf`;
  doc.save(filename);
  return filename;
}
